import {createAction} from "redux-act";

export interface IBannerSettings {
	isForceHub: boolean;
}

export interface IWinner {
	roundId: number;
	userId: number;
	username: string;
}

export interface ISettings {
	banner: IBannerSettings;
	winner: IWinner | null;
}

export const fetchSettingsRequest = createAction();
export const fetchSettingsSuccess = createAction<ISettings>();
